import { IIfProps } from './types';

export const If = ({
  condition,
  children,
  anotherChildren = null,
}: IIfProps) => {
  return <>{condition ? children : anotherChildren}</>;
};
